// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Cards/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.683 5.458H4.817c-.234 0-.45.009-.65.017-1.975.117-2.5.842-2.5 3.092v.483c0 .458.375.833.833.833H15a.836.836 0 0 0 .833-.833v-.483c0-2.484-.633-3.109-3.15-3.109ZM2.5 11.133a.836.836 0 0 0-.833.834v2.425c0 2.483.633 3.108 3.15 3.108h7.866c2.475 0 3.125-.6 3.15-2.975v-2.558a.836.836 0 0 0-.833-.834H2.5Zm3.3 4.334H4.375a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.433a.63.63 0 0 1 .625.625.631.631 0 0 1-.633.625Zm4.658 0H7.592a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h2.866a.624.624 0 1 1 0 1.25Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 11.108V6.742C18.333 4.133 16.842 3 14.592 3H7.15c-.633 0-1.2.092-1.7.283-.392.142-.742.35-1.025.625-.15.142-.033.375.183.375h9.059a3.39 3.39 0 0 1 3.391 3.392v5.975c0 .208.225.325.375.175.575-.608.9-1.5.9-2.717Z"
}));
export default CardsIcon;